import React from 'react';

import { HighlightedTile } from 'apps/promo/components/common/highlighted-tile/HighlightedTile';
import { PromoDangerouslyHtml } from 'apps/promo/components/common/promo-dangerously-html/PromoDangerouslyHtml';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import { BgColor, TextColor, TextGradient } from 'apps/promo/components/types';

import styles from './OverviewCardsSection.module.css';

interface HighlightedTileColor {
    titleColor?: TextColor;
    titleGradient?: TextGradient;
    bgColor?: BgColor;
}

interface HighlightedTileData {
    id: string | number;
    icon?: string | string[];
    title?: string;
    text?: string;
    color?: HighlightedTileColor;
}

interface OverviewCardsSectionProps {
    data?: HighlightedTileData[];
    title?: string;
    text?: string;
    promoDarkPageNew?: boolean;
}

export const OverviewCardsSection: React.FC<OverviewCardsSectionProps> = (props) => {
    const hasData = props.data && Array.isArray(props.data);

    return (
        <div className={styles.container}>
            <div className={styles.textContainer}>
                {props.title && (
                    <div className={styles.titleContainer}>
                        <PromoText tag="h2" variant="h2" color="white">
                            {props.title}
                        </PromoText>
                    </div>
                )}
                {props.text && <PromoDangerouslyHtml tag="div" color="gray40" dangerouslyHtml={props.text} />}
            </div>
            {hasData && (
                <div className={styles.tiles}>
                    {props
                        .data!.filter((item) => item !== null)
                        .map((item) => (
                            <HighlightedTile
                                key={item.id}
                                promoDarkPageNew={props.promoDarkPageNew}
                                icon={item.icon}
                                title={item.title}
                                text={item.text}
                                color={item.color?.titleColor}
                                titleGradient={item.color?.titleGradient}
                                bgColor={item.color?.bgColor}
                                variant="plainNoMinHeight"
                            />
                        ))}
                </div>
            )}
        </div>
    );
};
